var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileFueling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1506_698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.699951 6.44888H6.29995V0.848877H0.699951V6.44888ZM2.09995 2.24888H4.89995V5.04888H2.09995V2.24888Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.699951 13.4489H6.29995V7.84888H0.699951V13.4489ZM2.09995 9.24888H4.89995V12.0489H2.09995V9.24888Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69995 0.848877V6.44888H13.3V0.848877H7.69995ZM11.9 5.04888H9.09995V2.24888H11.9V5.04888Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2999 12.0488H11.8999V13.4488H13.2999V12.0488Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09995 7.84888H7.69995V9.24888H9.09995V7.84888Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 9.24878H9.09985V10.6488H10.4999V9.24878Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09995 10.6489H7.69995V12.0489H9.09995V10.6489Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 12.0488H9.09985V13.4488H10.4999V12.0488Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9 10.6489H10.5V12.0489H11.9V10.6489Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9 7.84888H10.5V9.24888H11.9V7.84888Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2999 9.24878H11.8999V10.6488H13.2999V9.24878Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1506_698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.148926)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileFueling);
export default __webpack_public_path__ + "static/media/mobileFueling.8f4f691f8171c59373bcfa61ac0b9522.svg";
export { ForwardRef as ReactComponent };